function showCartErrorNotification(message) {
  const notification = document.createElement('div');
  notification.className = 'cart-error-notification';
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    padding: 16px 20px;
    border-radius: 12px;
    z-index: 10000;
    font-size: 14px;
    max-width: 350px;
    transform: translateX(400px);
    transition: transform 0.3s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  `;
  
  notification.innerHTML = `
    <div style="display: flex; align-items: center; gap: 12px;">
      <div style="font-size: 20px;"></div>
      <div>
        <div style="font-weight: 600; margin-bottom: 4px;">Unable to add to cart</div>
        <div style="opacity: 0.9; font-size: 13px;">${message}</div>
      </div>
    </div>
    <button onclick="this.closest('.cart-error-notification').remove()" style="position: absolute; top: 8px; right: 8px; background: none; border: none; color: white; cursor: pointer; font-size: 18px; opacity: 0.7;">×</button>
  `;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
  }, 100);
  
  setTimeout(() => {
    if (notification.parentElement) {
      notification.style.transform = 'translateX(400px)';
      setTimeout(() => notification.remove(), 300);
    }
  }, 6000);
}

class ProductCard {
  selectedVariant = null;
  variants = [];
  variantOptionGroupElems = [];
  selectedOptions = [];
  priceElem = null;
  compareAtPriceElem = null;
  saleBadge = null;
  addToCartBtn = null;
  variantIdElem = null;
  formElem = null;

  constructor(card) {
    this.card = card;
    this.productId = card.dataset.productId;
    this.init();
  }

  init() {
    this.extractElems();
    this.extractVariantData();
    this.setupVariantOptionGroupElems();
    this.preselectFirstOptions(); // Pre-select first options before setting up selectors
    this.setupVariantSelectors();
    this.updateSelectedVariant();
    this.setupForm();
  }

  extractElems() {
    this.priceElem = this.card.querySelector('.current-price');
    this.compareAtPriceElem = this.card.querySelector('.compare-price');
    this.saleBadge = this.card.querySelector('.sale-badge');
    this.addToCartBtn = this.card.querySelector(".add-to-cart-btn");
    this.variantIdElem = this.card.querySelector("form input.variant-id");
  }

  extractVariantData() {
    const variantScripts = this.card.querySelectorAll(".product-form .variant-data");
    if (variantScripts.length === 0) {
      console.error(`No variant data found for product ${this.productId}`);
      return;
    }

    const variantIdSet = new Set();

    variantScripts.forEach(script => {
      try {
        const variantId = script.dataset.variantId;

        if (!variantId) {
          throw new Error("Variant Id not found in script")
        }

        if (variantIdSet.has(variantId)) {
          return;
        }
        
        const variant = JSON.parse(script.textContent);
        this.variants.push(variant);
        variantIdSet.add(variantId);
      } catch (e) {
        console.error('Error parsing variant data:', e, script.textContent);
      }
    });
  }

  setupForm() {
    this.formElem = this.card.querySelector(".ajax-cart-form");
    if (!this.formElem) {
      console.error("No Product Form Found");
      return;
    }

    this.formElem.addEventListener('submit', async (e) => {
     
      e.preventDefault();
      let btnText = null;
      let btnLoading = null;
      let isError = false;

      if (this.addToCartBtn) {
        btnText = this.addToCartBtn.querySelector(".btn-text");
        btnLoading = this.addToCartBtn.querySelector(".btn-loading");

        if (btnText && btnLoading) {
          btnText.style.display = 'none';
          btnLoading.style.display = 'inline';
        }

        this.addToCartBtn.disabled = true;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: this.selectedVariant.id,
            quantity: 1
          })
        });

        if (!response.ok) {
          const err = await response.json();
          throw err;
        }

        const cartData = await response.json();

        this.refreshCartDrawer();

        if (btnText && btnLoading) {
          btnLoading.textContent = '✓ Added!';
        } else {
          this.addToCartBtn.textContent = '✓ Added!';
        }

        this.openCartDrawer();
      } catch (error) {
        isError = true;
        console.error('Error adding to cart:', error);
        let errorMessage = 'Unable to add item to cart';
        if (error.message) {
          errorMessage = error.message;
        } else if (error.description) {
          errorMessage = error.description;
        } else if (error.status) {
          errorMessage += ` (Status: ${error.status})`;
        }

        showCartErrorNotification(errorMessage);
      }

      setTimeout(() => {
        if (btnText && btnLoading) {
          btnText.style.display = 'inline';
          btnLoading.style.display = 'none';
          btnLoading.style.color = '';
          btnLoading.textContent = 'Adding...';
        } else {
          this.addToCartBtn.textContent = isError ? 'Try Again' : 'Add to Cart';
        }
        
        this.addToCartBtn.disabled = false;

      }, isError ? 3000 : 2000);
    })
  }

  refreshCartDrawer() {
    const cartRefreshEvent = new CustomEvent('cart-drawer:refresh', {});
    document.dispatchEvent(cartRefreshEvent);
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer.hasAttribute("open")) {
      setTimeout(() => {
        cartDrawer.toggleDrawerClasses();
      })
    }
  }

  setupVariantOptionGroupElems() {
    const seen = new Set();

    const variantOptionGroups = this.card.querySelectorAll('.variant-option-group[data-option]');
    if (variantOptionGroups.length <= 0) {
      console.error("!! Variant Option Groups Not Found !!")
      return;
    }

    this.variantOptionGroupElems = Array.from(variantOptionGroups).filter(item => !seen.has(item.dataset.option) && seen.add(item.dataset.option));
  }

  preselectFirstOptions() {
    // Pre-select the first option in each variant group
    this.variantOptionGroupElems.forEach((elem) => {
      // Check if it's a dropdown
      const dropdown = elem.querySelector('.variant-dropdown');
      if (dropdown && dropdown.options.length > 0) {
        dropdown.selectedIndex = 0; // Select first option
      } else {
        // Check if it has radio buttons
        const firstRadio = elem.querySelector('.variant-radio');
        if (firstRadio) {
          firstRadio.checked = true;
          
          // Update visual state for the first radio
          const label = this.card.querySelector(`label[for="${firstRadio.id}"]`);
          if (label && label.classList.contains('variant-button')) {
            label.style.backgroundColor = '#FFF';
            label.style.border = '1px solid #BCBEA7';
          }
        }
      }
    });
  }

  setupVariantSelectors() {
    // Handle radio buttons with click event on labels to prevent link interference
    const variantLabels = this.card.querySelectorAll(".variant-button");
    
    variantLabels.forEach(label => {
      label.addEventListener('click', (e) => {
        // Prevent the parent link from being triggered
        e.preventDefault();
        e.stopPropagation();
        
        // Get the associated radio button - SEARCH WITHIN THIS CARD ONLY
        const radioId = label.getAttribute('for');
        const radio = this.card.querySelector(`#${radioId}`);
        
        if (!radio || radio.disabled) {
          console.warn(`Radio button not found or disabled: ${radioId}`);
          return;
        }
        
       
        
        // Manually check the radio button - THIS MUST HAPPEN FIRST
        radio.checked = true;
        
        // Verify it's actually checked
      
        
        // Update visual state of all radio buttons in the same group (within this card only)
        const allRadiosInGroup = this.card.querySelectorAll(`input[name="${radio.name}"]`);
        allRadiosInGroup.forEach(r => {
          const associatedLabel = this.card.querySelector(`label[for="${r.id}"]`);
          if (associatedLabel && associatedLabel.classList.contains('variant-button')) {
            if (r.checked) {
              associatedLabel.style.backgroundColor = '#FFF';
              associatedLabel.style.border = '1px solid #BCBEA7';
            } else {
              associatedLabel.style.backgroundColor = '#EFF2D9';
              associatedLabel.style.border = 'none';
            }
          }
        });
        
        // NOW call updateSelectedVariant after radio is definitely checked
        this.updateSelectedVariant();
      });
    });
    
    // Also set up initial visual state for pre-checked radios
    const checkedRadios = this.card.querySelectorAll('.variant-radio:checked');
    checkedRadios.forEach(radio => {
      const label = this.card.querySelector(`label[for="${radio.id}"]`);
      if (label && label.classList.contains('variant-button')) {
        label.style.backgroundColor = '#FFF';
        label.style.border = '1px solid #BCBEA7';
      }
    });

    // Handle dropdowns
    const variantDropdowns = this.card.querySelectorAll(".variant-dropdown");
    variantDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', (e) => {
        e.stopPropagation(); // Prevent link from triggering
        this.updateSelectedVariant();
      });
      
      // Also prevent click on dropdown from triggering parent link
      dropdown.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
  }

updateAddToCartBtn() {
    if (!this.addToCartBtn) {
      console.error("Add to Cart Button Not Found");
      return;
    }

    const variantPriceElem = this.addToCartBtn.querySelector(".variant-price");

    if (variantPriceElem) {
      let priceText = this.selectedVariant.price_formatted;

      // Add slashed compare price if higher than current price
      if (this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price) {
        priceText += ` <s>${this.selectedVariant.compare_at_price_formatted}</s>`;
      }

      variantPriceElem.innerHTML = priceText;
    }

    this.addToCartBtn.disabled = !this.selectedVariant.available;
}


updatePrice() {
    if (!this.priceElem) {
      console.warn("Price Element Not Found");
      return;
    }

    this.priceElem.textContent = `From ${this.selectedVariant.price_formatted}`
}

updateCompareAtPrice() {
    if (!this.compareAtPriceElem) {
      console.warn("Compare At Price Element Not Found");
      return;
    }

    // Never add "From" here
    if (this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price) {
      this.compareAtPriceElem.textContent = this.selectedVariant.compare_at_price_formatted;
    } else {
      this.compareAtPriceElem.textContent = '';
    }
}

  updateSaleBadge() {
    if (!this.saleBadge) {
      console.warn("Sale Badge Not Found");
      return;
    }

    const discount = Math.round(((this.selectedVariant.compare_at_price - this.selectedVariant.price) / this.selectedVariant.compare_at_price) * 100);
    this.saleBadge.textContent = `${discount}% OFF`;
    this.saleBadge.style.display = 'inline-block';
  }

  updateSelectedVariant() {
 
    
    if (this.variants.length == 0) {
      console.error("Variant details not found");
      return;
    }

    if (this.variantOptionGroupElems.length == 0) {
      console.error("Variant Option Group not found");
      return;
    }

    // Clear selected options array
    this.selectedOptions = [];

    // Get selected values from both radio buttons AND dropdowns
    this.variantOptionGroupElems.forEach((elem) => {
      const optionIndex = parseInt(elem.dataset.option);

      let selectedValue = null;
      
      // Check for dropdown first
      const dropdown = elem.querySelector('.variant-dropdown');
      if (dropdown) {
        selectedValue = dropdown.value;
       
      } else {
        // If no dropdown, check for radio button within THIS card only
        const selectedRadio = elem.querySelector('.variant-radio:checked');
       
        if (selectedRadio) {
          selectedValue = selectedRadio.value;
         
        } else {
         
          // Check if there are any radios at all
          const allRadios = elem.querySelectorAll('.variant-radio');
        
          allRadios.forEach((r, i) => {
           
          });
        }
      }
      
      if (!selectedValue) {
        console.error(`No variant is selected for option ${optionIndex}`);
        return;
      }
      
      this.selectedOptions[optionIndex] = selectedValue; 
    });

   

    this.selectedVariant = this.variants.find(variant =>
      this.selectedOptions.every((val, i) => {
        const matches = variant[`option${i+1}`] === val;
        
        return matches;
      })
    );

    if (!this.selectedVariant) {
      console.error("No matching variant found for selected options", this.selectedOptions);
      return;
    }

   
    this.variantIdElem.value = this.selectedVariant.id;

    this.updatePrice();
    this.updateCompareAtPrice();
    this.updateSaleBadge();
    this.updateAddToCartBtn();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const allProductCards = document.querySelectorAll(".product-card[data-product-id][data-product-card]");
  allProductCards.forEach(card => new ProductCard(card));
})